export default () => ({
  statusAllCourses: "",
  allCourses: [],
  statusToken: "",
  statusBookCourse: "",
  bookCourse: undefined,
});
